import React, { FC } from 'react'
import { Col } from 'react-bootstrap'
import { Helmet } from 'react-helmet'
import { useTranslation } from 'react-i18next'
import { Sidebar } from './Sidebar'
import Timeout from './Timeout'

export const Layout: FC<{ title: string; Component: any }> = ({ title, Component }) => {
  const { t } = useTranslation()
  return (
    <>
      <Timeout />
      <Helmet>
        <title>eperi Gateway [{t(title)}]</title>
      </Helmet>
      <Col lg='2' md='3' sm='12' className='p-0'>
        <Sidebar />
      </Col>
      <Col lg='10' md='9' sm='12' className='pt-3'>
        <Component />
      </Col>
    </>
  )
}
